<ion-content [fullscreen]="true">
  <div>
    <section class="business-summary-section">
      <div>
        <app-business-avatar [avatarUrl]="_imageUrl" (upload)="updateImage($event)"></app-business-avatar>
        <label class="ic-plus-label" for="single" aria-label="Change business logo">
          <ion-icon id="ic-plus" color="primary" name="add-circle" aria-hidden="true"></ion-icon>
        </label>
      </div>
      <div class="business-info profile-header-clickable" (click)="goToMyProfile()" (keydown.enter)="goToMyProfile()" tabindex="0">
        <ion-label>
          <p class="business-name">{{ businessName }}</p>
          <p class="view-profile-hint">View Business Profile</p>
        </ion-label>
      </div>
    </section>

    <ion-list>
      <ion-item lines="none" [button]="true" (click)="goToSettings()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Settings</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Preferences, Donation Visibility</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToTeamManagement()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Team Management</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Invite and Manage Team Members</ion-note>
        </ion-label>
      </ion-item>

      <ion-item lines="none" [button]="true" (click)="goToShopifyManagement()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Shopify Management</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">Manage Your Shopify Integration</ion-note>
        </ion-label>
      </ion-item>

      @if (canViewDonationHistory) {
        <ion-item lines="none" [button]="true" (click)="goToStripeManagement()">
          <div class="unread-indicator-wrapper" slot="start"></div>
          <ion-label>
            <ion-text>Stripe Connect</ion-text>
            <br />
            <ion-note color="medium" class="ion-text-wrap">Manage Your Stripe Account</ion-note>
          </ion-label>
        </ion-item>
      }

      <ion-item lines="none" [button]="true" (click)="goToOrders()">
        <div class="unread-indicator-wrapper" slot="start"></div>
        <ion-label>
          <ion-text>Orders</ion-text>
          <br />
          <ion-note color="medium" class="ion-text-wrap">View and Fulfill Orders</ion-note>
        </ion-label>
      </ion-item>

      @if (canViewDonationHistory) {
        <ion-item lines="none" [button]="true" (click)="goToDonationHistory()">
          <div class="unread-indicator-wrapper" slot="start"></div>
          <ion-label>
            <ion-text>Donation History</ion-text>
            <br />
            <ion-note color="medium" class="ion-text-wrap">View Business Donations</ion-note>
          </ion-label>
        </ion-item>
      }
    </ion-list>

    <div class="btn-user">
      <button (click)="switchToUserPortal()">Switch to User Portal</button>
    </div>

    <div class="btn-signout">
      <button (click)="signOut()">Log Out</button>
    </div>
  </div>
</ion-content>

